import i18next from "i18next";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { syncLocales } from "@/lib/utils";

export const useSyncLocales = () => {
	const translation = useTranslation();

	useEffect(() => {
		syncLocales(i18next.language);

		translation.i18n.on("languageChanged", syncLocales);
		return () => {
			translation.i18n.off("languageChanged", syncLocales);
		};
	}, [translation]);
};
